import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const API = process.env.REACT_APP_API_URL || 'http://localhost:8000';
const hdr = () => ({ Authorization: `Bearer ${localStorage.getItem('token')}` });

const RENK = { kritik: '#e74c3c', yuksek: '#e67e22', normal: '#2980b9', dusuk: '#27ae60' };
const DURUM_RENK: Record<string, string> = {
  yeni: '#3498db', islemde: '#e67e22', askida: '#95a5a6',
  tamamlandi: '#27ae60', arsiv: '#7f8c8d',
};

function OzetKart({ baslik, deger, alt, renk, onClick }: any) {
  return (
    <div onClick={onClick} style={{
      background: '#fff', border: `2px solid ${renk}22`, borderRadius: 10,
      padding: '16px 20px', cursor: onClick ? 'pointer' : 'default',
      boxShadow: '0 1px 4px rgba(0,0,0,.06)',
    }}>
      <div style={{ fontSize: 13, color: '#888', marginBottom: 4 }}>{baslik}</div>
      <div style={{ fontSize: 28, fontWeight: 700, color: renk }}>{deger}</div>
      {alt && <div style={{ fontSize: 11, color: '#aaa', marginTop: 2 }}>{alt}</div>}
    </div>
  );
}

export default function IsTakipPano() {
  const nav = useNavigate();
  const [pano, setPano]       = useState<any>(null);
  const [detay, setDetay]     = useState<any>(null);
  const [yukleniyor, setYuk]  = useState(true);

  useEffect(() => {
    Promise.all([
      fetch(`${API}/api/is-takip/pano`, { headers: hdr() }).then(r => r.json()),
      fetch(`${API}/api/is-takip/bildirimler/detay`, { headers: hdr() }).then(r => r.json()),
    ]).then(([p, d]) => { setPano(p); setDetay(d); }).finally(() => setYuk(false));
  }, []);

  if (yukleniyor) return <div style={{ padding: 32, color: '#888' }}>Yükleniyor...</div>;

  const tOrani = pano?.eylemler?.tamamlanma_orani ?? 0;

  return (
    <div style={{ padding: '20px 24px', maxWidth: 1100 }}>
      <h2 style={{ margin: '0 0 20px', fontSize: 18, color: '#1a3c5e' }}>📊 İş & Toplantı Takip Panosu</h2>

      {/* Özet Kartları */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill,minmax(200px,1fr))', gap: 14, marginBottom: 24 }}>
        <OzetKart baslik="Toplam Konu" deger={pano?.konular?.toplam ?? 0} renk="#2980b9" onClick={() => nav('/is-takip')} />
        <OzetKart baslik="Aktif Konu" deger={pano?.konular?.aktif ?? 0} renk="#e67e22" onClick={() => nav('/is-takip')} />
        <OzetKart baslik="Tamamlanan" deger={pano?.konular?.tamamlanan ?? 0} renk="#27ae60" />
        <OzetKart baslik="Toplantı" deger={pano?.toplantilar?.toplam ?? 0} renk="#8e44ad" onClick={() => nav('/toplanti')} />
        <OzetKart baslik="Bekleyen Karar" deger={pano?.toplantilar?.bekleyen_karar ?? 0} renk="#e74c3c" />
        <OzetKart baslik="Geciken Eylem" deger={pano?.eylemler?.geciken ?? 0} renk="#e74c3c" />
      </div>

      {/* Tamamlanma Oranı */}
      <div style={{ background: '#fff', borderRadius: 10, padding: '16px 20px', marginBottom: 20, boxShadow: '0 1px 4px rgba(0,0,0,.06)' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
          <span style={{ fontSize: 13, color: '#555' }}>Eylem Tamamlanma Oranı</span>
          <span style={{ fontWeight: 700, color: '#27ae60' }}>{tOrani}%</span>
        </div>
        <div style={{ height: 10, background: '#eee', borderRadius: 5, overflow: 'hidden' }}>
          <div style={{ width: `${tOrani}%`, height: '100%', background: '#27ae60', borderRadius: 5, transition: 'width .5s' }} />
        </div>
        <div style={{ fontSize: 11, color: '#aaa', marginTop: 4 }}>
          {pano?.eylemler?.tamamlanan ?? 0} / {pano?.eylemler?.toplam ?? 0} eylem tamamlandı
        </div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 18 }}>
        {/* Geciken Eylemler */}
        <div style={{ background: '#fff', borderRadius: 10, padding: '14px 16px', boxShadow: '0 1px 4px rgba(0,0,0,.06)' }}>
          <div style={{ fontWeight: 700, fontSize: 13, color: '#e74c3c', marginBottom: 10 }}>
            ⚠️ Geciken Eylemler ({detay?.geciken_eylemler?.length ?? 0})
          </div>
          {detay?.geciken_eylemler?.length === 0 && <div style={{ color: '#bbb', fontSize: 12 }}>Geciken eylem yok</div>}
          {detay?.geciken_eylemler?.slice(0, 6).map((e: any) => (
            <div key={e.id} onClick={() => nav(`/is-takip/${e.konu_id}`)}
              style={{ borderBottom: '1px solid #f5f5f5', padding: '6px 0', cursor: 'pointer' }}>
              <div style={{ fontSize: 12, fontWeight: 600, color: '#333' }}>{e.aciklama.slice(0, 60)}</div>
              <div style={{ fontSize: 11, color: '#e74c3c' }}>
                Son tarih: {e.son_tarih} · {e.sorumlu_birim_ad || e.sorumlu_personel_ad || '—'}
              </div>
            </div>
          ))}
        </div>

        {/* Yaklaşan Son Tarihler */}
        <div style={{ background: '#fff', borderRadius: 10, padding: '14px 16px', boxShadow: '0 1px 4px rgba(0,0,0,.06)' }}>
          <div style={{ fontWeight: 700, fontSize: 13, color: '#e67e22', marginBottom: 10 }}>
            ⏰ Bu Hafta Biten ({detay?.yaklasan_eylemler?.length ?? 0})
          </div>
          {detay?.yaklasan_eylemler?.length === 0 && <div style={{ color: '#bbb', fontSize: 12 }}>Yaklaşan son tarih yok</div>}
          {detay?.yaklasan_eylemler?.slice(0, 6).map((e: any) => (
            <div key={e.id} onClick={() => nav(`/is-takip/${e.konu_id}`)}
              style={{ borderBottom: '1px solid #f5f5f5', padding: '6px 0', cursor: 'pointer' }}>
              <div style={{ fontSize: 12, fontWeight: 600, color: '#333' }}>{e.aciklama.slice(0, 60)}</div>
              <div style={{ fontSize: 11, color: '#e67e22' }}>
                Son tarih: {e.son_tarih} · {e.sorumlu_birim_ad || e.sorumlu_personel_ad || '—'}
              </div>
            </div>
          ))}
        </div>

        {/* Geciken Toplantı Kararları */}
        <div style={{ background: '#fff', borderRadius: 10, padding: '14px 16px', boxShadow: '0 1px 4px rgba(0,0,0,.06)', gridColumn: '1/-1' }}>
          <div style={{ fontWeight: 700, fontSize: 13, color: '#8e44ad', marginBottom: 10 }}>
            📋 Geciken Toplantı Kararları ({detay?.geciken_kararlar?.length ?? 0})
          </div>
          {detay?.geciken_kararlar?.length === 0 && <div style={{ color: '#bbb', fontSize: 12 }}>Geciken karar yok</div>}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill,minmax(280px,1fr))', gap: 8 }}>
            {detay?.geciken_kararlar?.slice(0, 8).map((kr: any) => (
              <div key={kr.id} onClick={() => nav(`/toplanti/${kr.toplanti_id}`)}
                style={{ border: '1px solid #f0e6ff', borderRadius: 7, padding: '8px 10px', cursor: 'pointer' }}>
                <div style={{ fontSize: 12, fontWeight: 600, color: '#333' }}>{kr.karar_metni.slice(0, 70)}</div>
                <div style={{ fontSize: 11, color: '#8e44ad', marginTop: 2 }}>
                  Son tarih: {kr.son_tarih} · {kr.sorumlu_personel_ad || '—'}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
